import Image3 from "../images/pic3.png";

function Section4() {
  const handleClick = () => {
    window.open(
      "https://donor.southtexasblood.org/donor/store/preview?utm_source=double_my_impact&utm_medium=landing_page&utm_campaign=twa_dontate&utm_content=stb&t",
      "_blan",
    );
  };
  return (
    <div className="bg-[#0a0a0ad8] flex flex-col md:flex-row justify-center items-center gap-12 text-white py-12 md:py-20 xl:py-32">
      <div className="flex md:w-1/2 justify-center max-w-[75%] px-6">
        <img src={Image3} alt="Kids at Camp" />
      </div>
      <div className="font-montserrat flex flex-col md:w-1/2 gap-4 md:gap-6 px-6 md:px-10 2xl:pr-36 text-center md:text-left">
        <div className="text-center md:text-left text-[39px] md:text-5xl xl:text-[72px] leading-[1.3]">
          A Forever Experience
        </div>
        <div className="text-[#D6D6D6] text-[22px] md:text-[28px] leading-[1.7]">
          During Camp Discovery, children will experience perhaps the best week
          of their life by swimming, climbing, laughing, dancing, singing,
          horseback riding, and simply being with other people who can relate to
          their situation.
        </div>
        <button
          className="donate-btn mt-6 md:mt-10 mx-auto md:mx-0"
          onClick={handleClick}
        >
          Donate Points
        </button>
      </div>
    </div>
  );
}

export default Section4;
